export default "__VITE_ASSET__o$BCv$ko__"